import React from "react";
import "./styles.scss";

const PricePopup = ({ isOpen, onClose, contentType }) => {
  if (!isOpen) return null;

  const contentMap = {
    privacy: `
    <h1>Privacy Policy</h1>
        <h2>1. Introduction</h2>
    <p>At CyberFortress Teknoloji Anonim Şirketi, we value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, protect, and share information when you use our platform, Malware Analyzer 360 (MA360). By using our platform, you agree to the terms of this policy.</p>
    
    <h2>2. Information Collected</h2>
    <ul>
      <li><strong>Personal Information:</strong> Name, surname, email address, payment details, username, and password.</li>
      <li><strong>Technical Information:</strong> IP address, device information, browser type, operating system, and similar technical data.</li>
      <li><strong>Usage Data:</strong> Your interactions on the platform, analysis results, file upload history, and similar data.</li>
    </ul>
    
    <h2>3. Use of Information</h2>
    <ul>
      <li>To provide, improve, and optimize our services.</li>
      <li>To manage user accounts and process membership plans.</li>
      <li>To monitor user activity for security purposes.</li>
      <li>To fulfill legal obligations.</li>
    </ul>
    
    <h2>4. Sharing of Information</h2>
    <p>Your personal information will not be shared with third parties except as required by law. However, anonymized data may be shared for analytical and statistical purposes.</p>
    
    <h2>5. Data Security</h2>
    <p>We implement appropriate technical and administrative measures to ensure the security of your data. However, no internet platform can be 100% secure, and we cannot eliminate all risks of data breaches.</p>
    
    <h2>6. Cookies</h2>
    <p>Our platform uses cookies to enhance the user experience. You can manage your cookie preferences through your browser settings.</p>
    
    <h2>7. Your Rights</h2>
    <p>You have the right to access, correct, delete, or object to the processing of your personal data. To exercise these rights, please contact us at <a href="mailto:info@cyber-fortress.com">info@cyber-fortress.com</a>.</p>
    
    <h2>8. Changes to the Policy</h2>
    <p>This Privacy Policy may be updated from time to time. Any changes will take effect immediately upon being posted on our platform.</p>
      `,
    agreement: `
    <h1>Distance Sales Agreement</h1>
        <h2>1. Parties</h2>
    <p>This agreement is between CyberFortress Teknoloji Anonim Şirketi (hereinafter referred to as the "Seller") and the user who purchases a membership plan through our platform (hereinafter referred to as the "Buyer").</p>
    
    <h2>2. Subject</h2>
    <p>The subject of this agreement is to define the terms of the membership plan purchased by the Buyer and the rights and obligations of the parties.</p>
    
    <h2>3. Formation of the Agreement</h2>
    <p>The Buyer accepts this agreement by selecting a membership plan and completing the payment process on our platform.</p>
    
    <h2>4. Membership Plans</h2>
    <ul>
      <li><strong>Basic Plan:</strong> Limited number of analyses and access to basic features.</li>
      <li><strong>Standard Plan:</strong> More analysis credits and access to advanced features.</li>
      <li><strong>Premium Plan:</strong> Unlimited analyses and access to all features.</li>
    </ul>
    
    <h2>5. Payment and Invoicing</h2>
    <p>Payments are made through credit card or other payment methods available on our platform. Invoices are sent electronically to the Buyer's email address.</p>
    
    <h2>6. Right of Withdrawal</h2>
    <p>The Buyer has the right to withdraw from the agreement within 14 days of purchasing the membership plan without providing any reason. To exercise this right, please contact us at <a href="mailto:info@cyber-fortress.com">info@cyber-fortress.com</a>.</p>
    
    <h2>7. Responsibilities</h2>
    <p>The Seller will make reasonable efforts to ensure the platform operates without interruption or errors. However, the Seller cannot be held responsible for issues arising from technical disruptions.</p>
    
    <h2>8. Disputes</h2>
    <p>Any disputes arising from this agreement shall be governed by the laws of [Country] and fall under the jurisdiction of the courts of [City].</p>
      `,
    delivery: `
    <h1>Delivery and Refund Terms</h1>
        <h2>1. Delivery</h2>
    <p>Membership plans are activated immediately upon completion of the payment process. The Buyer can log in to their account and start using the services.</p>
    
    <h2>2. Refund Terms</h2>
    <ul>
      <li>The Buyer may request a refund within the 14-day withdrawal period.</li>
      <li>Refund requests must be submitted via <a href="mailto:info@cyber-fortress.com">info@cyber-fortress.com</a>.</li>
      <li>Refunds will be processed within 7 business days, depending on the payment method.</li>
    </ul>
    
    <h2>3. Exceptions</h2>
    <ul>
      <li>Membership plans that have been used or benefited from are not eligible for refunds.</li>
      <li>Refund requests will not be accepted after the 14-day withdrawal period has expired.</li>
    </ul>
    
    <h2>4. Cancellation and Refund Process</h2>
    <ul>
      <li>Once a refund request is received, the Buyer's account will be reviewed, and if eligible, the refund process will begin.</li>
      <li>The Buyer will be notified once the refund process is complete.</li>
    </ul>
      `,
    terms: `
    <h1>Terms of Service</h1>
         <h2>1. Terms of Acceptance</h2>
    <p>These Terms of Service define the conditions for your use of MA360 services. By accessing or using MA360 services, you declare that you fully accept these terms. If you do not agree to these terms, you should not use our services. Furthermore, these terms may be updated from time to time. It is the user's responsibility to stay informed about such updates.</p>
    
    <h2>2. Description of Services</h2>
    <p>MA360 offers a cloud-based sandbox service for malware analysis and security. This service provides detailed reports by using static and dynamic analysis techniques to assess the security of your files. MA360 delivers AI-powered analyses and behavior-based inspections for malware detection, offering users an in-depth security evaluation. Additionally, users can securely access reports and analysis results through MA360.</p>
    
    <h2>3. Terms of Use</h2>
    <p>MA360 services must be used solely for lawful purposes and to ensure personal or organizational security. Users are strictly prohibited from using our system for any malicious, illegal, or unethical purposes. Users are required to comply with the laws of the Republic of Turkey and international legal regulations while using the service. MA360 reserves the right to restrict or terminate access to the service in cases of suspected misuse or abuse.</p>
    
    <h2>4. User Data and Privacy</h2>
    <p>Data collected during the use of the service is stored in accordance with our privacy policy and is not shared with third parties without user consent. MA360 employs industry-standard encryption and security measures to ensure the safety of user data. Users have the right to share, store, or permanently delete the results of their analyzed files. Furthermore, options are provided for users to control the retention period of their data. For more details about our privacy policy, please visit <a href="https://cyber-fortress.com/privacy" target="_blank">privacy policy link</a>.</p>
    
    <h2>5. Disclaimer of Liability</h2>
    <p>MA360 does not guarantee the absolute accuracy, uninterrupted access, or constant updates of the service. Results of analyses conducted on the system may not always be 100% accurate due to the limitations of the analysis methods used. Users are responsible for any damages or losses resulting from the use of information obtained through the service. MA360 accepts no liability for direct or indirect damages under any circumstances.</p>
    
    <h2>6. Service Modifications</h2>
    <p>MA360 reserves the right to modify its services, discontinue parts of the service, or cease the service entirely at any time. Users will be notified in advance of such changes, which will be considered accepted if the user continues to use the service. MA360 may regularly add new features or modify existing features to enhance the user experience.</p>
    
    <h2>7. Termination</h2>
    <p>In cases where users violate these terms of service, MA360 reserves the right to suspend or terminate access to its services. Additionally, users have the option to terminate their accounts and associated data upon request. In the event of termination, all user data will be deleted from the system and cannot be recovered. MA360 is not obligated to refund any fees previously paid by the user in case of termination.</p>
    
    <h2>8. Fees and Payment Terms</h2>
    <p>MA360 services may include both free and paid plans. Payment terms and pricing details for paid plans are explicitly stated during service use. By making a payment, the user is deemed to have accepted these pricing terms. MA360 reserves the right to make changes to its pricing, and users will be informed of such changes before they take effect.</p>
    
    <h2>9. Applicable Law</h2>
    <p>These Terms of Service will be governed by the laws of the Republic of Turkey. In the event of any disputes, the courts and enforcement offices of Istanbul will have jurisdiction. By accepting these terms, users agree to act in compliance with Turkish laws.</p>
    
    <h2>10. Contact</h2>
    <p>If you have any questions regarding these terms or our services, please contact us via <a href="mailto:info@cyber-fortress.com">info@cyber-fortress.com</a>. We value feedback from our users, and you can reach our support team for any questions, suggestions, or complaints. Support requests will be evaluated promptly, and you will receive a response as soon as possible.</p>
      `,
    contact: `
    <h1>Contact US</h1>
    <h2>Company Information</h2>
    <p>CyberFortress Teknoloji Anonim Şirketi</p>
    <p><b>Mersis:</b> 0216128585300001</p>
    <p><b>Address:</b> FETIH MAH. TAHRALI SK. KAVAKYELI NO: 7 D IC KAPI NO: 24 ATASEHİR/ ISTANBUL</p>
    <p><b>Tax:</b> 2161285853 | UMRANIYE</p>
    <p><b>E-mail Address:</b> info@cyber-fortress.com </p>
    <p><b>Tel:</b> +90 (216) 515 33 49 </p> 
    <a href="https://cyber-fortress.com/main/contact-us.html"> Send us a message </a>
      `,
  };

  const content = contentMap[contentType] || "";

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="pricePopup-overlay" onClick={handleOverlayClick}>
      <div className="pricePopup-content" onClick={(e) => e.stopPropagation()}>
        <button className="pricePopup-close" onClick={onClose}>
          &times;
        </button>
        <div className="pricePopup-body" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default PricePopup;
